import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import AnalyzerFieldSelector from "./AnalyzerFieldSelector";
import {custom} from "../../utils/linker";
import {ComponentContext} from "../../contexts";

function AnalyzerRow(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compStore=useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);


  return (
    <div className="vpadd5">
      <div className="up12 margin">
        <div className="cell s-6">
          <div className="pbottom5 bold">
            {props.linker.value.name}
          </div>
          <div>
            {props.linker.value.samples && props.linker.value.samples.length?(
              <div className="fs12">
                {props.linker.value.samples.map((item, index)=>{
                  return <div key={index} className="pbottom2">{item}</div>
                })}
              </div>
            ):null}
          </div>
        </div>
        <div className="cell s-3">
          <label>
            <input type="radio" name="unique_field" checked={compStore.mapper[props.linker.value.name].use_as_indexa} onChange={(e)=>{
                if(e.target.checked) {
                  compStore.setUseAsIndex(props.linker.value.name);
                }
              }}
            /><span></span>
          </label>
        </div>
        <div className="cell s-3">
          <AnalyzerFieldSelector code={props.linker.value.name} />
        </div>
      </div>
    </div>
  )
};

AnalyzerRow.defaultProps = {};

AnalyzerRow.propTypes = {}

export default observer(AnalyzerRow);
